import { createContext, useContext } from 'react';

import { StaffUser } from './types';

type ShopRequestsContextType = {
  staffUsers: StaffUser[];
};

export const ShopRequestsContext = createContext<ShopRequestsContextType>({
  staffUsers: [],
});

export const useShopRequestsContext = () => useContext(ShopRequestsContext);
